import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';
import { API_BASE_URL } from '../constants/api';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: createAuthBaseQuery(API_BASE_URL),
  tagTypes: ['Report'],
  endpoints: (builder) => ({
    listReports: builder.query({
      query: ({ status, search } = {}) => {
        const params = new URLSearchParams();
        if (status) params.set('status', status);
        if (search) params.set('search', search);
        const qs = params.toString();
        return `/reports${qs ? `?${qs}` : ''}`;
      },
      providesTags: ['Report'],
    }),
    getReport: builder.query({
      query: (reportId) => `/reports/${encodeURIComponent(reportId)}`,
      providesTags: (_r, _e, id) => [{ type: 'Report', id }],
    }),
  }),
});

export const { useListReportsQuery, useGetReportQuery } = reportsApi;
